import { routes } from 'app/routing/routesConfig';
import { NavTabs } from 'app/components/Core/ChakraNavTabs';
import { useAppSelector } from 'app/store';
import { getCreateReleaseValidations } from 'app/store/Releases/selectors';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';

export const ProfileNavTabs = () => {
  const releaseValidation = useAppSelector(getCreateReleaseValidations);
  const showConnectionsList =
    releaseValidation && releaseValidation?.type?.enum?.length > 1;

  return (
    <ContentContainer type={ContentContainerType.FORM}>
      <NavTabs
        id="profile-nav-tabs"
        w="full"
        routes={[
          routes.profileBasic,
          routes.profileIDs,
          routes.profileCredits,
          ...(showConnectionsList ? [routes.profileConnections] : []),
          routes.profileRepresentatives,
        ]}
      />
    </ContentContainer>
  );
};
